import React from 'react';
import Routing from './components/Layout/Routing.js';
import './App.css';

function App() {
  return (
    <div className="App">
      <Routing />
    </div>
  );
}

export default App;
